module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9008HD_white-7750aaa9dd201d462c95089a30788aca.png";